/* src/app/modules/subscription/contact-sales-dialog/contact-sales-dialog.component.css */
.contact-sales-dialog {
  display: flex;
  flex-direction: column;
  max-width: 800px;
  height: 100%;
}
.dialog-header {
  padding: 18px 24px 0;
}
.dialog-header h2 {
  margin: 0 0 6px;
  font-size: 1.4rem;
  font-weight: 700;
  color: #0f172a;
}
.dialog-header p {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
}
.dialog-content {
  padding: 12px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  overflow-y: auto;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.form-group label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
}
.form-group .form-control {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.9rem;
  box-shadow: none;
  outline: none;
}
.form-group .form-control:focus {
  border-color: var(--cf-brand-dark);
  box-shadow: 0 0 0 3px rgba(212, 143, 0, 0.15);
}
.dialog-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  gap: 10px;
  text-align: center;
}
.dialog-result mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.result-ok mat-icon {
  color: #16a34a;
}
.result-error mat-icon {
  color: #dc2626;
}
.dialog-result h3 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
}
.dialog-result p {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 24px 16px;
  border-top: 1px solid #e2e8f0;
}
.btn-cancel-dialog {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  border-radius: 8px;
  padding: 9px 18px;
  font-weight: 600;
  cursor: pointer;
}
.btn-cancel-dialog:hover {
  background: #f8fafc;
}
/*# sourceMappingURL=contact-sales-dialog.component.css.map */
